/* unplugin-vue-components disabled */import script from "./MoreUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreUpload.vue?vue&type=script&setup=true&lang=js"

import "./MoreUpload.vue?vue&type=style&index=0&id=da3cbcbe&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da3cbcbe"]])

export default __exports__